import { Injectable, EventEmitter } from "@angular/core"
import { throwError, Observable, of, Subscription } from "rxjs"
import { catchError, map } from "rxjs/operators"
import { HttpHeaders, HttpClient } from "@angular/common/http"
import { Router } from "@angular/router"
import { environment } from "src/environments/environment"
import { ServiceLocator } from "./locator.service"
import { ToastrService, ToastrConfig } from "ngx-toastr"
import { TranslateService } from "@ngx-translate/core"

declare var $: any

@Injectable()
export class HelpersService {
	public mockPayload = {
		open_stream_ab: { for: "openfiber_map", of_data: { service_name: "open_stream", cluster: "ab" } },
		open_stream_cd: { for: "openfiber_map", of_data: { service_name: "open_stream", cluster: "cd" } },
		open_internet_ab: { for: "openfiber_map", of_data: { service_name: "open_internet", cluster: "ab" } },
		open_internet_cd: { for: "openfiber_map", of_data: { service_name: "open_internet", cluster: "cd" } },
		pre_provisioning_kit: { for: "openfiber_map", of_data: { service_name: "pre_provisioning", cluster: "kit" } },
		pre_provisioning_svlan: {
			for: "openfiber_map",
			of_data: { service_name: "pre_provisioning", cluster: "svlan" }
		},
		gpon_ab: { for: "openfiber_map", of_data: { service_name: "gpon", cluster: "ab" } },
		gpon_cd: { for: "openfiber_map", of_data: { service_name: "gpon", cluster: "cd" } }
	}
	public receivedPayload: any = {}
	public activePayload: any = {}

	// Storage
	private storageLanguage = "of-storage-lang"

	// Events
	public notifications: EventEmitter<any> = new EventEmitter()

	public DEFAULT_LANG = "en"
	public lang = this.DEFAULT_LANG
	public pathImgsMarkers = environment.path_imgs_markers
	public toastrOptions = {
		closeButton: true,
		newestOnTop: true,
		progressBar: false,
		positionClass: "toast-bottom-center",
		preventDuplicates: false,
		timeOut: 4000,
		extendedTimeOut: 1000
	}
	protected translate: TranslateService
	public toastr: ToastrService

	constructor(
		protected http: HttpClient,
		protected router: Router
	) {
		this.toastr = ServiceLocator.injector.get(ToastrService)
		this.translate = ServiceLocator.injector.get(TranslateService)
	}

	// Api

	public getHTTPHeader() {
		return {
			headers: new HttpHeaders({
				"Content-Type": "application/json",
				Accept: "application/ld+json",
				"Accept-Language": this.lang
			})
		}
	}

	public handleError(error: Response, operation: string = null) {
		switch (error.status) {
			case 400:
				break
			case 401:
				// this.logout();
				break
			case 500:
				break
		}
		return throwError(error)
	}

	sendMessageInterface(data) {
		console.log("INVIO POST MESSAGE", data)
		parent.postMessage({ for: data.for, of_data: data }, environment.IFRAME_PARENT)
	}

	// sendMessageInterface(data) {
	//     console.log('INVIO POST MESSAGE', data);
	//     parent.postMessage({ "for": data.for, "of_data": data }, 'https://eofdev-open-fiber.cs174.force.com/OFLightning');
	// }
	sendInitConfirm() {
		console.log("INVIO POST MESSAGE INIT")
		parent.postMessage({ for: "openfiber", of_data: "ready" }, environment.IFRAME_PARENT)
	}

	// sendInitConfirm() {
	//     console.log('INVIO POST MESSAGE INIT');
	//     parent.postMessage({ "for": "openfiber", "of_data": 'ready' }, 'https://eofdev-open-fiber.cs174.force.com/OFLightning');a
	// }

	// Toastr
	public showSuccess(text) {
		text = text ? text : "Operation completed successfully"
		this.toastr.success(text, "", this.toastrOptions)
	}

	public showError(e) {
		const errorMsg =
			e.error && e.error.error && e.error.error.message ? e.error.error.message : "Invalid credentials"
		this.toastr.error(errorMsg, "", this.toastrOptions)
	}

	// Translate

	public instant(key, params = null) {
		return this.translate.instant(key, params)
	}

	public useLanguage(langCode: string) {
		this.translate.use(langCode)
		this.lang = langCode
	}

	// Functions

	public open(content) {
		$("#" + content).modal("show")
	}

	public close(content) {
		$("#" + content).modal("hide")
	}

	alreadyExists(obj, list) {
		for (let i = 0; i < list.length; i++) {
			if (list[i].id === obj.id) {
				return true
			}
		}
		return false
	}
}
